// 门户首页：三个大学科入口。
import { el, routeLink, topbar } from "../lib";

export function portalView(root: HTMLElement): void {
  document.title = "小朋友学习乐园";
  root.appendChild(topbar([]));

  const hero = el("header", "portal-hero");
  hero.appendChild(el("div", "hero-emoji", "🎉"));
  hero.appendChild(el("h1", "hero-title", "小朋友学习乐园"));
  root.appendChild(hero);

  const grid = el("div", "portal-grid");

  const english = routeLink("/english", "subject-card subject-english");
  english.appendChild(el("div", "sc-emoji", "🔤"));
  english.appendChild(el("div", "sc-name", "英语"));
  english.appendChild(el("div", "sc-sub", "故事 · 音频"));
  grid.appendChild(english);

  const chinese = routeLink("/chinese", "subject-card subject-chinese is-disabled");
  chinese.appendChild(el("div", "sc-emoji", "📖"));
  chinese.appendChild(el("div", "sc-name", "语文"));
  chinese.appendChild(el("div", "sc-badge", "敬请期待"));
  grid.appendChild(chinese);

  const math = routeLink("/math", "subject-card subject-math is-disabled");
  math.appendChild(el("div", "sc-emoji", "🔢"));
  math.appendChild(el("div", "sc-name", "数学"));
  math.appendChild(el("div", "sc-badge", "敬请期待"));
  grid.appendChild(math);

  root.appendChild(grid);
  root.appendChild(el("footer", "page-foot", "🏠 仅供家里的小朋友使用"));
}
